export const COLUMN_LIST = [
  { label: 1, value: 1 },
  { label: 2, value: 2 },
  { label: 3, value: 3 },
  { label: 4, value: 4 },
  { label: 5, value: 5 },
  { label: 6, value: 6 },
  // { label: 7, value: 7 },
  // { label: 8, value: 8 },
  // { label: 9, value: 9 },
  // { label: 10, value: 10 },
];

export const OPERATION_TYPE_LIST = [
  { label: '加法运法', value: '+' },
  { label: '减法运法', value: '-' },
  { label: '乘法运法', value: '*' },
  { label: '除法运法', value: '/' },
  { label: '混合运算', value: 'mixin' },
];